import React, { useContext, useEffect, useMemo, useState } from "react";
import styles from "@/page-components/cost-explorer/components/filter-section/filter-section.module.css";
import {
  FilterSearch,
  FilterSearchToggle,
} from "@/components/filter-search/filter-search";
import clsx from "clsx";
import FilterState from "@/components/States/FilterState";
import { BillingContext } from "../../billing-context.part";
import { useBillingAccounts } from "@/services/billing-credit/getBillingAccount.repo";

const CreditFilterSection = ({ service, name }) => {
  const Context = useContext(BillingContext);
  const query = useMemo(() => {
    return {
      service: service,
      accountType: Context?.account,
    };
  }, [Context?.account, service]);
  const { data, isLoading, error } = useBillingAccounts(query);
  const [selectedTittle, setSelectedTittle] = useState(null);

  useEffect(() => {
    Context?.setBillingAccount([]);
  }, [Context?.accountType]);

  return (
    <>
      {isLoading && <FilterState />}
      {(data || error) && !isLoading && (
        <div className={styles.filter_main_div}>
          <Filter
            tittle={name}
            setSelectedTittle={setSelectedTittle}
            data={data?.data}
            filterType="account"
            isLoading={isLoading}
            // selectedValues={Context?.billingAccount}
            selectedValues={
              Array.isArray(Context?.billingAccount)
                ? Context?.billingAccount
                : []
            }
            onSelect={(list) => {
              Context?.setBillingAccount(list);
            }}
            onRemove={(list) => {
              Context?.setBillingAccount(list);
            }}
          />
        </div>
      )}
    </>
  );
};

const Filter = ({
  tittle,
  data,
  isLoading,
  setSelectedTittle,
  filterType,
  selectedValues,
}) => {
  const Context = useContext(BillingContext);
  const [tempSelectedValues, setTempSelectedValues] = useState([]);
  const [currentSelectedValues, setCurrentSelectedValues] = useState([]);
  const [applyTrue, setApplyTrue] = useState(false);
  const handleSelect = (selectedList) => {
    if (filterType === "account") {
      Context?.setBillingAccount(selectedList);
    }
  };

  const handleRemove = (selectedList) => {
    handleSelect(selectedList);
  };

  const handleTittle = (title) => {
    if (title === "Subscription Name" || tittle === "Account Name") {
      title = "Account";
    }
    setSelectedTittle(title?.toLowerCase());
  };

  const handleApply = () => {
    handleSelect(tempSelectedValues);
    setCurrentSelectedValues(tempSelectedValues);
  };

  const handleCancel = () => {
    setTempSelectedValues(currentSelectedValues);
  };

  useEffect(() => {
    setTempSelectedValues(selectedValues);
    setCurrentSelectedValues(selectedValues);
  }, [selectedValues]);

  return (
    <>
      <div className={clsx(styles.filter_padding_div)}>
        <div className={clsx(styles.dimension_div)}>
          <div className={styles.dimension_name_css}>{tittle}</div>
          <div
            onClick={() => handleTittle(tittle)}
            className={clsx(styles.filter_group_name_css)}
          >
            <FilterSearch
              multiselect={true}
              showApply
              applyTrue={applyTrue}
              setApplyTrue={setApplyTrue}
              loading={isLoading}
              options={(data || []).map((e) => {
                return {
                  id: e.id,
                  name: e.name,
                };
              })}
              selectedValues={tempSelectedValues}
              onSelect={(list) => setTempSelectedValues(list)}
              onRemove={(list) => setTempSelectedValues(list)}
              displayValue="name"
              placeholder="--Select--"
              toggle={
                <>
                  <FilterSearchToggle placeholder={tittle} />
                </>
              }
              onCancel={() => {
                handleCancel();
              }}
              onApply={() => {
                handleApply();
              }}
            />
          </div>
        </div>
      </div>
    </>
  );
};

export default CreditFilterSection;
